import type { IconType } from 'react-icons';
import {
  FiClock,
  FiDollarSign,
  FiMoreHorizontal,
  FiNavigation,
  FiPackage,
  FiUserMinus,
} from 'react-icons/fi';

export type MarketplaceDeclineReasonId =
  | 'niche'
  | 'rate'
  | 'timeline'
  | 'product'
  | 'brand'
  | 'other';

export interface MarketplaceDeclineReasonOption {
  id: MarketplaceDeclineReasonId;
  title: string;
  description: string;
  Icon: IconType;
}

export const MARKETPLACE_DECLINE_REASON_OPTIONS: MarketplaceDeclineReasonOption[] = [
  {
    id: 'niche',
    title: "Doesn't match my niche",
    description: "Content style or audience isn't aligned.",
    Icon: FiNavigation,
  },
  {
    id: 'rate',
    title: 'Rate is too low',
    description: "Budget doesn't match the scope of work.",
    Icon: FiDollarSign,
  },
  {
    id: 'timeline',
    title: 'Timeline is too tight',
    description: "I can't deliver by the deadline.",
    Icon: FiClock,
  },
  {
    id: 'product',
    title: "I don't use this product",
    description: "I'd rather only promote things I actually use.",
    Icon: FiPackage,
  },
  {
    id: 'brand',
    title: "Brand isn't the right fit",
    description: 'Values or reputation concerns.',
    Icon: FiUserMinus,
  },
  {
    id: 'other',
    title: 'Other',
    description: 'Tell us more below.',
    Icon: FiMoreHorizontal,
  },
];
